export default __webpack_public_path__ + "static/media/2.956ba37b.jpg";